import { Stack, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import OZDataGrid from "../../../components/admin/common/OZDataGrid/OZDataGrid";
import OZGridToolbar from "../../../components/admin/common/OZDataGrid/OZGridToolbar";
import LoadingScreen from "../../../components/admin/common/OZLoadingScreen/OZLoadingScreen";
import useReportsStatusFileDownload from "../../../hooks/useReportsStatusFileDownload";
import { adminService } from "../../../services/admin-services";
import { getLastFetchedDetailFromBrowser } from "../../../services/application-service";
import { ReactComponent as RefreshOutlinedIcon } from '../../../static/icons/refresh.svg';
import "../../reports/ReportsStatus/reportStatus.css";

const ReportStatusAdmin = () => {
    const [gridRef, setGridRef] = useState(null);
    const [loading, setLoading] = useState(false);
    const [downloadReportList, setDownloadReportList] = useState([]);
    const [lastFetchedTime, setLastFetchedTime] = useState(null);
    const { handleDownloadReportFile } = useReportsStatusFileDownload()

    const loadingStyle = useMemo(
        () => ({
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: '0,0,0,0.5',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }), []
    );

    useEffect(() => {
        const controller = new AbortController();
        getDownloadDataList(controller);
        return () => controller.abort();
    }, []);

    async function getDownloadDataList(controller) {
        setDownloadReportList([]);
        setLoading(true);

        try {
            const resp = await adminService({
                urlParams: 'api/fileStatus/admin',
                method: 'GET',
                controller,
            });
            if (resp && resp?.Status === "Success" && resp?.Data?.length > 0) {
                setDownloadReportList(resp?.Data);
            } else {
                setDownloadReportList([]);
            }
            setLastFetchedTime(getLastFetchedDetailFromBrowser());
        } catch (e) {
            setDownloadReportList([]);
        } finally {
            setLoading(false);
        }
    }

    const columnDefs = [
        { field: 'transactionId', headerName: 'Transaction Id', minWidth: 260 },
        { field: "reportName", headerName: "Report Name", minWidth: 200 },
        { field: 'status', headerName: 'Status', maxWidth: 100 },
        {
            field: 'filePath', headerName: 'Uploaded File', cellRenderer: (params) => {
                return params?.data?.filePath && <button style={{ color: '#3D8BF8', textDecoration: 'none', border: 'none', background: "transparent", cursor: "pointer" }} onClick={() => handleDownloadReportFile(params.data)}>
                    {params?.data?.exportType ? `Download ${params?.data?.exportType}` : "Download"}
                </button>;
            }
        },
        {
            field: 'failedFilePath', headerName: 'Errors', cellRenderer: (params) => {
                return params.data?.failedFilePath && <button style={{ color: '#3D8BF8', textDecoration: 'none', border: 'none', background: "transparent", cursor: "pointer" }} onClick={() => handleDownloadReportFile(params.data)}>
                    {params?.data?.exportType ? `Download ${params?.data?.exportType}` : "Download"}
                </button>;
            }
        },
        { field: 'createdTimestamp', headerName: 'Start Time', },
        { field: 'updatedTimestamp', headerName: 'End Time', },
    ];

    return (
        <div className="ozAdminMusicContainer">
            <Stack direction="row" sx={{ marginBottom: "16px" }} >
                <Typography className="oz-page-header">Configurations</Typography>
            </Stack>
            <Stack direction="row" sx={{ marginBottom: "16px" }}>
                <Typography className="oz-page-heading" minWidth={'180px'} flexGrow={'unset !important'}>Report Status</Typography>
                <div style={{ display: 'flex', alignItems: 'start', cursor: 'pointer', marginTop: '6px', marginRight: '2px' }}>
                    <div className="refresh-btn card-icon" style={{ marginBottom: '-7px' }}
                        onClick={() => {
                            getDownloadDataList();
                        }}>
                        <RefreshOutlinedIcon fontSize="small" style={{ color: '#536580' }} />
                    </div>
                    <span className="last-fetched-time" style={{ marginLeft: '10px', alignItems: 'center' }}>Last fetched at: {lastFetchedTime} </span>
                </div>
            </Stack>
            {!loading ? <>
                <OZGridToolbar title='List of Reports Status'
                    rowCount={downloadReportList.length}
                    displayedRowCount={downloadReportList.length}
                    hideSearch={false}
                    hideDownload={true}
                    dataGridRef={gridRef} fileName='Reports_Status_Admin' />
                <OZDataGrid
                    totalData={downloadReportList.length}
                    height="26.3rem"
                    data={downloadReportList}
                    columns={columnDefs}
                    setGridRef={setGridRef}
                />
            </> : null
            }

            {loading &&
                <div style={loadingStyle}>
                    <LoadingScreen />
                </div>
            }
        </div >
    );
};

export default ReportStatusAdmin;
